import React from 'react';
import { Dropdown, Menu } from 'antd';
import { DropdownContainer, SelectedOption, StyledDropdown, StyledMenu, StyledMenuItem } from './DropdownLUXE-styled';
import { SvgIcon } from '../../../shared/UIHelpers/SvgIcon/SvgIcon';

interface IDropdownOption {
  value:string,
  label:string
}

interface Props {
  options:IDropdownOption[],
  defaultOption:IDropdownOption,
  onChange:(value:string)=>void,
  disabled?:boolean,
  highlight?:boolean
}

export class DropdownLUXE extends React.Component<Props,{}> {
  constructor(props) {
    super(props)
  }

  public handleChange = (value) => {
    const { onChange } = this.props;
    onChange(value);
  }

  public render = () => {
    const { options, defaultOption, disabled, highlight } = this.props;

    return (
      <DropdownContainer highlight={highlight}>
        <StyledDropdown className="threed-configurator-dropdown"
          overlay={
            <StyledMenu
              onClick={(option) => { this.handleChange(option.key) }}
            >
              {options.map((option) =>
                <StyledMenuItem
                  key={option.value}
                  isSelected={option.value === defaultOption.value}
                  onClick={(e) => e.domEvent.stopPropagation()}
                >
                  {option.label}
                </StyledMenuItem>
              )}
            </StyledMenu>
          }
          trigger={['click']}
          disabled={disabled}
          placement={'bottomLeft'}
        >
          <SelectedOption className="threed-configurator-dropdown-selected-option">
            {defaultOption.label}
            <SvgIcon className="threed-configurator-svg-icon"
              type="arrowLeft"
            />
          </SelectedOption>
        </StyledDropdown>
      </DropdownContainer>
    )
  }
};